import { createFileRoute } from "@tanstack/react-router";
import InstallApp from "@/pages/InstallApp";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/instaleaza-aplicatia/")({
  head: () => routeHead("/instaleaza-aplicatia/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <InstallApp />
  );
}
